//Vaccum Collections
jQuery(document).ready(function($) {
  var imageSrc = 'https://cdn.shopify.com/s/files/1/0247/4691/7985/files/brand-logos.png?v=1687398275';
  var $image = $('<img>').attr('src', imageSrc).addClass('brand-list');
  $('.navmenu-id-vacuum .navmenu-depth-3').append($image);
});

//Vaccum Parts Collections
jQuery(document).ready(function($) {
  var imageSrc = 'https://cdn.shopify.com/s/files/1/0247/4691/7985/files/brand-logos.png?v=1687398275';
  var $image = $('<img>').attr('src', imageSrc).addClass('brand-list');
  $('.navmenu-id-vacuum-parts .navmenu-depth-3').append($image);
}); 

//Chemicals Collections
jQuery(document).ready(function($) {
  var imageSrc = 'https://cdn.shopify.com/s/files/1/0247/4691/7985/files/brand-logos.png?v=1687398275';
  var $image = $('<img>').attr('src', imageSrc).addClass('brand-list');
  $('.navmenu-id-chemicals .navmenu-depth-3').append($image);
}); 

//Janitorial Supplies Collections
jQuery(document).ready(function($) {
  var imageSrc = 'https://cdn.shopify.com/s/files/1/0247/4691/7985/files/brand-logos.png?v=1687398275';
  var $image = $('<img>').attr('src', imageSrc).addClass('brand-list');
  $('.navmenu-id-janitorial-supplies .navmenu-depth-3').append($image);
}); 

//Window Cleaning Collections
jQuery(document).ready(function($) {
  var imageSrc = 'https://cdn.shopify.com/s/files/1/0247/4691/7985/files/brand-logos.png?v=1687398275';
  var $image = $('<img>').attr('src', imageSrc).addClass('brand-list');
  $('.navmenu-id-window-cleaning .navmenu-depth-3').append($image);
}); 
 
//Garbage bag bin liners Collections
jQuery(document).ready(function($) {
  var imageSrc = 'https://cdn.shopify.com/s/files/1/0247/4691/7985/files/brand-logos.png?v=1687398275';
  var $image = $('<img>').attr('src', imageSrc).addClass('brand-list');
  $('.navmenu-id-garbage-bags-bin-liners .navmenu-depth-3').append($image);
});

//Cleaning equipment Collections
jQuery(document).ready(function($) {
  var imageSrc = 'https://cdn.shopify.com/s/files/1/0247/4691/7985/files/brand-logos.png?v=1687398275';
  var $image = $('<img>').attr('src', imageSrc).addClass('brand-list');
  $('.navmenu-id-cleaning-equipment .navmenu-depth-3').append($image);
});

//Power equipment Collections
jQuery(document).ready(function($) {
  var imageSrc = 'https://cdn.shopify.com/s/files/1/0247/4691/7985/files/brand-logos.png?v=1687398275';
  var $image = $('<img>').attr('src', imageSrc).addClass('brand-list');
  $('.navmenu-id-power-equipment .navmenu-depth-3').append($image);
});